import React from 'react';

const UserListItemDesktop = ({ person }) => {
  return (
    <li className="grid grid-cols-5 items-center gap-4 px-2 py-1 [&:not(:last-child)]:border-b [&:not(:last-child)]:border-solid [&:not(:last-child)]:border-gray-300 [&:nth-child(even)]:bg-gray-100">
      <p className="overflow-hidden text-ellipsis whitespace-nowrap text-base">
        {person.firstName} {person.lastName}
      </p>
      <p className="overflow-hidden text-ellipsis whitespace-nowrap text-base">
        {person.email}
      </p>
      <p className="overflow-hidden text-ellipsis whitespace-nowrap text-base">
        {person.phone}
      </p>
    </li>
  );
};

export default UserListItemDesktop;
